import React from 'react';
import { ToastProvider } from 'react-toast-notifications';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { ErrorBoundary } from 'react-error-boundary';
import { GoogleOAuthProvider } from '@react-oauth/google';

import client from './graphql';
import { store } from './redux/store';
// import { store } from './redux/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import SomethingWentWrong from './components/SomethingWentWrong';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.scss';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <ErrorBoundary fallback={<SomethingWentWrong />}>
    <React.StrictMode>
      <Provider store={store}>
        <ToastProvider>
          <BrowserRouter>
            <ApolloProvider client={client}>
              <GoogleOAuthProvider clientId={process.env.REACT_APP_GIS_CLIENT_ID as string}>
                <App />
              </GoogleOAuthProvider>
            </ApolloProvider>
          </BrowserRouter>
        </ToastProvider>
      </Provider>
    </React.StrictMode>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
